<template>
  <!-- <b-tab ref="tab__completed" tle="Completed" lazy> -->
  <div ref="tab__completed" tle="Completed" lazy>
    <div slot="title">
      <!-- <span ref="span__completed-tab" class="font-size-md active span__completed-tab"
        >Completed</span
      > -->

      <!-- <div class="divider"></div> -->
    </div>

    <TablePaymentDetail ref="tablePayment" :orders="purchaseOrder" />

    <b-pagination
      ref="pagination"
      v-model="$_currentPage"
      :total-rows="totalItems"
      :per-page="perPage"
      first-number
      last-number
      align="center"
    />
  </div>
  <!-- </b-tab> -->
</template>

<script>
import TablePaymentDetail from '@/views/Payment/components/TablePaymentDetail.vue';

export default {
  components: {
    TablePaymentDetail
  },
  model: {
    prop: 'vModel',
    event: 'change'
  },

  props: {
    active: {
      type: [Number, Boolean],
      default: false
    },
    purchaseOrder: { type: Array, default: () => [] },
    perPage: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    vModel: {
      type: Number,
      default: 1,
      required: true
    }
  },
  computed: {
    $_currentPage: {
      get() {
        return this.vModel;
      },
      set(v) {
        return this.$emit('change', v);
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
